import './App.css';
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Projects from "./pages/projects.js";
import Contact from "./pages/contact.js";
import Resume from "./pages/experience.js";

function App() {

  return (
    <Router>
      <div className="app">
        {/* Header */}
        <header className="header">
          <h1>Charles Carroll</h1>
          <nav>
            <ul>
              <li><NavLink to="/" end className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Projects</NavLink></li>
              <li><NavLink to="/contact" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Contact</NavLink></li>
              <li><NavLink to="/resume" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Resume</NavLink></li>
            </ul>
          </nav>
        </header>

        {/* Page Content */}
        <main>
          <Routes>
            <Route path="/" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resume" element={<Resume />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
